import ValidationError from './validation-error'

class Validation {
	constructor() {
		this.target = '';
		this.selector = '';
		this.rule = '';
		this.checker = '';
		// Things that can be useful in the future:
		// 1) Get specific behavior instance for specific form:
		// wFORMS.getBehaviorInstance(document.querySelector('.dr-form form'), 'validation');
	}

	init(drForm) {
		drForm.querySelector(this.target).classList.add(this.selector);
		wFORMS.behaviors.validation.rules[this.rule] = {
			selector: '.' + this.selector,
			check: this.checker,
		};
		wFORMS.behaviors.validation.instance.prototype[this.checker] = this.check.bind(this);
	}

	check(field, value) {
		try {
			return this.validate(value);
		} catch (e) {
			if (e instanceof ValidationError && e.message) {
				wFORMS.behaviors.validation.messages[this.rule] = e.message;
			} else {
				console.error(e.message);
				wFORMS.behaviors.validation.messages[this.rule] = 'Sorry, we have some problems validating your input. Try again later.';
			}
			return false;
		}
	}

	validate(value) {
		return true;
	}
}

export default Validation;
